import httpClient from "@/services/base.service.js";

export default {
  search: function (searchCriteria) {
    return httpClient.post(`/api/v1/addressbookcontact/search/`, searchCriteria)
  } 
};
